import AssetService from '../../../../shared/services/AssetService';
import ColorPickerService from '../../../../shared/services/ColorPickerService';
import { ColumnAsset } from '../../../models/LessonComponentContent';
import { ColumnProps } from './Column';
import Grid from '@mui/material/Unstable_Grid2';
import LessonComponentService from '../../../services/LessonComponentService';
import React from 'react';
import styles from '../../../styles/Column.module.css';
import { useTheme } from '@mui/material/styles';

export default function ColumnView(props: ColumnProps) {
  const muiTheme = useTheme();
  const fontFamily = muiTheme.typography.fontFamily;
  const columns: ColumnAsset[] = props.component?.content?.column;
  const position = props.component?.settings.textPosition;

  return (
    <div className={styles.gridContainer} style={{ fontFamily }}>
      {columns?.map((column, index) => (
        <div
          key={index}
          style={{
            padding: column?.text ? '30px' : '0px',
            alignItems: position,
            backgroundColor: column?.backgroundColor
              ? ColorPickerService.rgbToHex(column.backgroundColor)
              : undefined
          }}
          className={`${styles.columnContainer} ${
            column.assetkey ? styles.imageColumn : styles.textColumn
          }`}
        >
          {column?.assetkey && (
            <img
              className={styles.image}
              src={AssetService.getAssetUrl(column.assetkey)}
            />
          )}
          {column?.text && (
            <Grid
              className={`style-p ${styles.textContainer} column-item-position ${props.component.settings?.textPosition}`}
            >
              <span
                className={`ql-editor`}
                dangerouslySetInnerHTML={{
                  __html: LessonComponentService.getUrlWithSas(column?.text)
                }} //value has been sanitized before storing into db.
              ></span>
            </Grid>
          )}
        </div>
      ))}
    </div>
  );
}
